// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"647":"977c7570","787":"ad4af407"}[chunkId] + ".chunk.js";
};